import { render, staticRenderFns } from "./ZoneDetails.vue?vue&type=template&id=3b4f1d39&scoped=true"
import script from "./ZoneDetails.vue?vue&type=script&lang=js"
export * from "./ZoneDetails.vue?vue&type=script&lang=js"
import style0 from "./ZoneDetails.vue?vue&type=style&index=0&id=3b4f1d39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f1d39",
  null
  
)

export default component.exports